<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div mat-dialog-title class="matDialogTitle" cdkDragHandle>
        <div class="div_loading">
            <div class="my-container" [hidden]="!loading">
                <mat-progress-bar mode="indeterminate" class="detaile"></mat-progress-bar>
            </div>
        </div>
        <span>
            <span>{{ title }}</span>
        </span>
        <span (click)="close()">
            <mat-icon class="close">close</mat-icon>
        </span>
    </div>
</div>


<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="number" class='wh-label'>
                    <span *ngIf="lang == 1"> مقدار: </span>
                    <input class='wh-input' formControlName="number" autocomplete="off"
                        [attr.disabled]="not_update_ckd2 == true ? true : null" currencyMask [readonly]="readonly"
                        required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="price" class='wh-label'>
                    <span *ngIf="lang == 1"> قیمت واحد به تومان : </span>
                    <input class='wh-input' formControlName="price" autocomplete="off" currencyMask
                        [attr.disabled]="not_update_ckd2 == true ? true : null" currencyMask [readonly]="readonly"
                        required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="price" class='wh-label'>
                    <span *ngIf="lang == 1"> تخفیف به تومان : </span>
                    <input class='wh-input' formControlName="discount" autocomplete="off" currencyMask
                        [attr.disabled]="not_update_ckd2 == true ? true : null" currencyMask [readonly]="readonly"
                        required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="pert" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب پرت: </span>
                    <input class='wh-input' formControlName="pert" autocomplete="off" [readonly]="readonly" required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="nasb" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب نصب: </span>
                    <input class='wh-input' formControlName="nasb" autocomplete="off" [readonly]="readonly" required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="sod" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب سود: </span>
                    <input class='wh-input' formControlName="sod" autocomplete="off" [readonly]="readonly" required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="haml" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب حمل داخلی: </span>
                    <input class='wh-input' formControlName="haml" autocomplete="off" [readonly]="readonly" required>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="haml2" class='wh-label'>
                    <span *ngIf="lang == 1"> ضریب حمل خارجی: </span>
                    <input class='wh-input' formControlName="haml2" autocomplete="off" [readonly]="readonly" required>
                </label>
            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
            *ngIf="type_task == 1 || type_task == 2" [hidden]="readonly">
            <span *ngIf="lang == 2">Save</span>
            <span *ngIf="lang == 1">ذخیره</span>
        </button>
        <button type="button" (click)="search(1)" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
            <span *ngIf="lang == 2">Search</span>
            <span *ngIf="lang == 1">جستجو</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3" (click)="search(2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>